import { constants } from "redux/constants/redux-constants";
const initialState = {
  value: null,
};

export default function startupScreenReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SCRIBE.SET_STARTUP_SCREEN:
      return { ...state, value: action.payload };
    default:
      return state;
  }
}
